import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import FamilyService from '@/modules/families/FamilyService';
var family = {
  name: '',
  categories: []
};
export function restoreFamilysOrder() {
  var savedItems = JSON.parse(localStorage.getItem('items') || '[]');

  if (savedItems.length) {
    localStorage.removeItem('items');
  }
}

var FamilyModel =
/** @class */
function (_super) {
  __extends(FamilyModel, _super);

  function FamilyModel() {
    var _this = _super.call(this, family, FamilyService) || this;

    _this.modelName = 'Mesa';
    _this.request = 'JSON';
    return _this;
  }

  FamilyModel.prototype.create = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, Promise, function () {
      var createValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.create.call(this, data, toast, toastConfig)];

          case 1:
            createValue = _a.sent();
            restoreFamilysOrder();
            return [2
            /*return*/
            , createValue];
        }
      });
    });
  };

  FamilyModel.prototype.update = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, Promise, function () {
      var updateValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.update.call(this, data, toast, toastConfig)];

          case 1:
            updateValue = _a.sent();
            restoreFamilysOrder();
            return [2
            /*return*/
            , updateValue];
        }
      });
    });
  }; // tslint:disable-next-line:max-line-length


  FamilyModel.prototype.delete = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, Promise, function () {
      var deleteValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.delete.call(this, data, toast, toastConfig)];

          case 1:
            deleteValue = _a.sent();
            restoreFamilysOrder();
            return [2
            /*return*/
            , deleteValue];
        }
      });
    });
  };

  return FamilyModel;
}(BaseModel);

export default FamilyModel;